
// This source is part of the Akeria  and is
// copyrighted by Uniphore system software limited.

// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 23-11-2019   1                  Pappuraj                          Development
// 30-11-2019   1.1                Pappuraj                           Bug fixed 
// 05-12-2019   1.2                Pappuraj                           otp issue fixed 
// 09 -12 -2019  1.3               Adhrish                            hide verify button when time is 00.00

import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router'
import { JsonPipe } from '@angular/common';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { ChangeDetectorRef } from '@angular/core';
import { async } from '@angular/core/testing';

// declare var SMSReceive: any;

@Component({
  selector: 'app-verifyotp',
  templateUrl: './verifyOtp.component.html',
  styleUrls: ['./verifyOtp.component.scss'],
})
export class VerifyOtpComponent implements OnInit {

  @ViewChild('ngOtpInput', { static: true }) ngOtpInput: any;


  languageConext: any;
  context: any;
  headerTitle: any;
  otp: string;
  showOtpComponent = true;
  currentpath;
  errorshow: boolean = false;
  counter: number = 60;
  resetcount: number = 0;
  resendcount: number = 0;
  resendOtpState = "";
  userId: any;
  mobileNo: any;
  emailid: any;
  resend: boolean = false;
  countertime: any;
  userInfo: any;
  demo: any;
  otp1: any;
  otp2: any;
  otp3: any;
  otp4: any;
  otp5: any;
  otp6: any;
  showfecthdetails: any = false;

  public smsTextmessage: string = '';
  public appHashString: string = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }

  };
  constructor(private router: Router,
    public navctrl: NavController,
    public platform: Platform,
    public cmndeclaration: CommonDeclarationService,
    public cmndef: CommonDefinitionService,
    public actionVal: ActionlistenService,
    public api: RestapiService, private cd: ChangeDetectorRef) {
    this.currentpath = this.router.url;

    // if(this.cmndeclaration.BrowserBuild != 1)
    // this.start();
    if (this.cmndeclaration.LanguageJson) {
      this.context = this.cmndeclaration.LanguageJson.pages[0]
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Newuser;
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.context = this.cmndeclaration.LanguageJson.pages[0];
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Newuser;
      console.log(this.languageConext)
    }
    this.headerTitle = this.languageConext.enterverificationcode.label;
    if(localStorage.role != undefined && localStorage.role == 'existing' && this.router.url != "/verifyOtp"){
      this.cmndeclaration.getstoreProcess("profile").then(async (data: any) => {
        if((data.mobileNo != undefined && data.mobileNo != "" && data.mobileNo != "0") || (data.emailID != undefined && data.emailID != ""))
          this.gettingData();
        else{
          this.showfecthdetails= true;
          this.fetchingdetails();
        }
      });
    }else
      this.gettingData();
  }

  fetchingdetails(){
    let req = {
      "mobileNo": localStorage.user,
      "requestType": "getProfileData",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }
    this.api.postapi("updateDetails", req).then(async (data: any) => {
      if((data.mobileNo != undefined && data.mobileNo != "" && data.mobileNo != "0") || (data.emailID != undefined && data.emailID != "")){
        console.log(data);
        data['state'] = localStorage.state;
        await this.cmndeclaration.storeProcess(data, "profile");
        this.gettingData();
      }else{
        this.fetchingdetails();
      } 
    });
  }

  gettingData() {
    this.cmndeclaration.getstoreProcess("profile").then(async (data: any) => {
      this.userInfo = data;
      console.log(data);
      if (this.currentpath == "/verifyOtpupdate" || this.currentpath == "/verifyemailOtpupdate") {
        this.userInfo.state = localStorage.state;
        this.showfecthdetails=false;
        this.countdown();
      }
      else if (this.currentpath == "/verifyOtpPassword") {
        let req = {
          "mobileNo": localStorage.user,
          "requestType": "getProfileData",
          "userSessionID": localStorage.userSessionID,
          "userChatSessionId": localStorage.userChatSessionId,
        }
        this.api.postapi("updateDetails", req).then(async data => {
          if (data) {
            console.log(data);
            data['state'] = localStorage.state;
            this.cmndeclaration.storeProcess(data, "profile");
            this.showfecthdetails=false;
            this.cmndef.Showtoast(this.context.alerts.otpSendReq);
            this.cmndeclaration.getstoreProcess("profile").then(data => {
              this.userInfo = data;
              this.userId = this.userInfo.mobileNo ? (this.userInfo.mobileNo.substring(0, 5) + ' ' + this.userInfo.mobileNo.substring(5, 15)) : this.userInfo.emailId;
              this.countdown();
            });
          }
        })
      }
      else if (this.currentpath == "/verifyOtpaddress") {
        let req = {
          "mobileNo": localStorage.user,
          "requestType": "getProfileData",
          "userSessionID": localStorage.userSessionID,
          "userChatSessionId": localStorage.userChatSessionId,
        }
        this.api.postapi("updateDetails", req).then(async data => {
          if (data) {
            data['state'] = localStorage.state;
            await this.cmndeclaration.storeProcess(data, "profile");
            await this.cmndeclaration.getstoreProcess("profile").then(data => {
              this.showfecthdetails=false;
              this.userInfo = data;
              console.log(this.userInfo)
              this.countdown();
            });
          }
        })
      }
      else if (this.currentpath == "/verifyOtpReg" || this.currentpath =='/verifyOtpVa') {
        this.showfecthdetails=false;
        this.userId = this.userInfo.mobileNo ? (this.userInfo.mobileNo.substring(0, 5) + ' ' + this.userInfo.mobileNo.substring(5, 15)) : ''
        this.emailid = this.userInfo.emailId;
        this.countdown();
      }
      else {
        this.showfecthdetails=false;
        this.userId = this.userInfo.mobileNo ? (this.userInfo.mobileNo.substring(0, 5) + ' ' + this.userInfo.mobileNo.substring(5, 15)) : this.userInfo.emailId;
        console.log("userid", this.userId)
        this.countdown();
      }
    });
  }

  ngOnInit() {

  }



  async resendOTP() {
    console.log(this.resendcount);
    this.otp1 = ""
    this.otp2 = ""
    this.otp3 = ""
    this.otp4 = ""
    this.otp5 = ""
    this.otp6 = ""

    this.resetcount++;
    this.errorshow = false;
    this.onConfigChange();
    console.log(this.otp)
    if (this.resendcount != 3) {
      this.resendcount++;
      var data = {
        // "state": userInfo.state,
        "state": this.resendOtpState ? this.resendOtpState : this.userInfo.state,
        "actionType": "RESEND"
      };

      /*api call for resending OTP */
      await this.api.postapi("otpRequest", data).then(response => {
        console.log(response);
        localStorage.state = response['state'];
        this.resendOtpState = response['state'];
        this.counter = 60;
        this.resend = false;
        this.countdown();
      }, function (err) { });
    }
    else {
      this.resend = false;
      let cdate = new Date();
      localStorage.setItem("freezetime", JSON.stringify(cdate));
      sessionStorage.CurrentPage = "/freezescreen";
      this.navctrl.navigateForward("/freezescreen")
      this.counter = 60;
      this.resend = true;
      this.resendcount = 0;
    }


  }


  appendZero(n) {
    return (n < 10 ? '00:0' : '00:') + n;
  }


  countdown() {
    let count;
    setTimeout(() => {
      this.counter--;
      if (this.counter >= 0) {
        this.countdown();
        count = (this.appendZero(this.counter));
        this.countertime = count;
      } else {
        this.resend = true;
      }
    }, 1000)
  }

  verify() {
    console.log(this.otp)
    let dummyotp;
    let ticketData: any
    if ((this.otp1 == undefined || this.otp1 == null || this.otp1 == "") ||
      (this.otp2 == undefined || this.otp2 == null || this.otp2 == "") ||
      (this.otp3 == undefined || this.otp3 == null || this.otp3 == "") ||
      (this.otp4 == undefined || this.otp4 == null || this.otp4 == "") ||
      (this.otp5 == undefined || this.otp5 == null || this.otp5 == "") ||
      (this.otp6 == undefined || this.otp6 == null || this.otp6 == "")) {

      this.errorshow = true;
      return
    }

    // if (this.otp) {
    //   dummyotp = this.otp.toString();
    // }
    // if (dummyotp == undefined || dummyotp == null || dummyotp == "" || dummyotp.length < 6) {
    //   this.errorshow = true;
    // }
    else {
      this.otp = this.otp1 + '' + this.otp2 + '' + this.otp3 + '' + this.otp4 + '' + this.otp5 + '' + this.otp6;
      var numpattern = /[0-9]/g;
      console.log(this.otp);
      var matifsc = (this.otp.match(numpattern) || []).length;
      console.log(matifsc);
      if (matifsc == 6) {
        this.errorshow = false;
        console.log("valid otp");
        var data = {
          "state": this.resendOtpState ? this.resendOtpState : this.userInfo.state,
          "actionType": "VERIFICATION",
          "otp": this.otp
        }
        this.api.postapi('otpRequest', data).then(response => {
          if (response) {
            console.log(response);
            
            this.otp1 = ""
            this.otp2 = ""
            this.otp3 = ""
            this.otp4 = ""
            this.otp5 = ""
            this.otp6 = ""

            if (this.currentpath == "/verifyOtpForgotPasscode") {
              sessionStorage.CurrentPage = "/resetPasscode"
              this.navctrl.navigateForward("/resetPasscode");

            }
            else if (this.currentpath == "/verifyOtpReg" || this.currentpath =='/verifyOtpVa') {
              sessionStorage.CurrentPage = "/confirmregister";
              this.navctrl.navigateForward("/confirmregister");

            }
            else if (this.cmndef.previousPage == "/forgotpassword") {
              sessionStorage.CurrentPage = "/forgotChangePassword";
              this.navctrl.navigateForward("/forgotChangePassword");
            }
            else if (this.currentpath == "/verifyOtpPassword") {
              sessionStorage.CurrentPage = "/changePassword";
              this.navctrl.navigateForward("/changePassword");

            } else if(this.cmndef.newPreviousPage == "/va/vasdetails") {
              console.log("the redirection starts here******************************************************************");
              console.log(this.cmndeclaration.DataStore);
              this.cmndef.loaderstart();
              this.api.postapi("akeiraVAAction", this.cmndeclaration.DataStore).then(async data => {
                let res = data;
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0]
                this.navctrl.navigateForward("/va/vasdetails");
                this.cmndef.newPreviousPage = '';
              });
            }
            else if (this.cmndef.previousPage == "/va/emailupdate") {
              console.log(this.cmndeclaration.DataStore);
              this.cmndef.loaderstart();
              this.api.postapi("akeiraVAAction", this.cmndeclaration.DataStore).then(async data => {
                let res = data;
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0]
                sessionStorage.CurrentPage = "/va/chat"
                this.navctrl.navigateRoot("/va/chat");
              })
            }
            else if (this.cmndef.previousPage == "/va/mobileupdate") {
              this.cmndef.loaderstart();
              this.api.postapi("akeiraVAAction", this.cmndeclaration.DataStore).then(async data => {
                let res = data;
                console.log(data);
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0]
                sessionStorage.CurrentPage = "/va/chat"
                this.navctrl.navigateRoot("/va/chat");
              });
            }
            else if (this.cmndef.previousPage == "/va/addressForm") {
              this.cmndef.loaderstart();
              let senddata = JSON.parse(this.cmndef.addressparams)
              this.api.postapi("akeiraVAAction", senddata).then(async data => {
                let res = data;
                console.log(data);
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0]
                sessionStorage.CurrentPage = "/va/chat"
                this.navctrl.navigateRoot("/va/chat");
              });
            }
            else if (this.cmndef.userType == 'new') {
              /*call login service for the new user type(p1) without passcode */
              this.loginAuth('');

            } else {
              sessionStorage.CurrentPage = "/profileInfo";
              this.navctrl.navigateRoot("/profileInfo");
            }
          }

        }, err => {
          console.log(err);
          this.otp1 = ""
          this.otp2 = ""
          this.otp3 = ""
          this.otp4 = ""
          this.otp5 = ""
          this.otp6 = ""
        })
      } else {
        this.errorshow = true;
      }

    }


  }

  loginAuth(passcode) {

    localStorage.user = this.userInfo.mobileNo;
    var loginData = {
      "requestType": "LOGIN",
      "mobileNo": this.userInfo.mobileNo,
      "passcode": passcode,
      "userSessionID": "",
      "channelId": "1"
    };
    var dataToStore = {
      "mobileNo": this.userInfo.mobileNo,
      "passCode": passcode,
      "timestamp": new Date().getTime()
    }
    // if(this.cmndeclaration.BrowserBuild != 1)
    //   this.stop();
    this.api.postapi('loginAuthentication', loginData).then(response => {
      localStorage.setItem("prospecttoexisting", 'true');
      dataToStore['userSession'] = response['userSessionID'];
      dataToStore['chatSession'] = response['userChatSessionId'];
      dataToStore['userType'] = 'new';
      localStorage.role = 'new';
      localStorage.userSessionID = response['userSessionID'];
      localStorage.userChatSessionId = response['userChatSessionId'];
      dataToStore['profileName'] = this.userInfo['customerName'] ? this.userInfo['customerName'] : "User";
      dataToStore['textToSpeech'] = false;
      dataToStore['talkback'] = false;

      if ((localStorage.getItem("pushToken") != null) && (localStorage.getItem("pushToken") != "")) {
        var deviceToken = localStorage.getItem("pushToken");
        var data = {
          "requestType": "FCMDATA",
          "uniqueId": this.userInfo.mobileNo,
          "deviceId": deviceToken
        }
        this.api.postapi("updateDetails", data).then(res => {
        }, function (err) {
          console.log(err);
        });
      }

      localStorage.setItem("setUserData", JSON.stringify(dataToStore))
      this.cmndef.profileName = dataToStore['profileName'];
      this.cmndeclaration.deletefile();
      this.cmndeclaration.ChatFullHistory = [];
      this.cmndeclaration.ChatfullList = [];
      this.cmndeclaration.capsuleList = [];
      if (localStorage.proshowtouse == undefined || localStorage.proshowtouse == "") {
        localStorage.proshowtouse = "shown"
        this.cmndeclaration.howtouse = true;
        let d = localStorage.getItem('configPage');
        let dparse = JSON.parse(d);
        dparse = dparse.values;
        console.log(dparse);
        var count = 1;
        var df = [];
        for (var s = 0; s < dparse.length; s++) {
          count = count + 1;
          if (dparse[s].popupType == 'P' && dparse[s].popupDeviceType == 'A') {
            df.push('0');
          } else {
            df.push('1');
          }
        }
        var bannnervisited = localStorage.getItem('banner');
        if (df.indexOf("0") !== -1 && bannnervisited != 'displayed') {
          sessionStorage.CurrentPage = "/va/popupconfig"
          this.navctrl.navigateRoot("/va/popupconfig");
        } else {
          sessionStorage.CurrentPage = "/va";
          this.navctrl.navigateRoot("/va");
        }
      }
      else {
        sessionStorage.CurrentPage = "/va";
        this.navctrl.navigateRoot("/va");
      }
    })
  }

  onOtpChange(otp) {
    this.otp = otp;
    console.log(this.otp)
  }


  validatefun(event: any, flg: any) {
    if (flg == 'otp1') {
      // if (this.otp1 != undefined)
      this.otp1 = this.otp1.replace(/[^0-9]/g, '');
    }
    else if (flg == 'otp2') {
      // if (this.otp2 != undefined)
      this.otp2 = this.otp2.replace(/[^0-9]/g, '');
    }
    else if (flg == 'otp3') {
      // if (this.otp3 != undefined)
      this.otp3 = this.otp3.replace(/[^0-9]/g, '');
    }
    else if (flg == 'otp4') {
      // if (this.otp4 != undefined)
      this.otp4 = this.otp4.replace(/[^0-9]/g, '');
    }
    else if (flg == 'otp5') {
      // if (this.otp5 != undefined)
      this.otp5 = this.otp5.replace(/[^0-9]/g, '');
    }
    else if (flg == 'otp6') {
      // if (this.otp6 != undefined)
      this.otp6 = this.otp6.replace(/[^0-9]/g, '');
    }


  }







  moveFocus(event, next, prev) {
    if (event.target.value.length < 1 && prev) {
      prev.setFocus()
    }
    else if (next && event.target.value.length > 0) {
      next.setFocus();
    }
    else {
      return 0;
    }
  }


  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

  // start() {
  //   console.log("enabled");
  //   SMSReceive.startWatch(
  //     () => {
  //       document.addEventListener('onSMSArrive', (e: any) => {
  //         var IncomingSMS = e.data;
  //         this.processSMS(IncomingSMS);
  //       });
  //     },
  //     () => { console.log('watch start failed') }
  //   )
  // }

  // stop() {
  //   SMSReceive.stopWatch(
  //     () => { console.log('watch stopped') },
  //     () => { console.log('watch stop failed') }
  //   )
  // }

  // processSMS(data) {
  //   let OTP: any;
  //   const message = data.body;
  //   if(message != "" && message != null){
  //     console.log(message)
  //     var matches = message.match(/(\d+)/); 
  //     console.log(matches);
  //     console.log();
  //     OTP = matches[0].split("");
  //     this.otp1 = OTP[0];
  //     this.otp2 = OTP[1];
  //     this.otp3 = OTP[2];
  //     this.otp4 = OTP[3];
  //     this.otp5 = OTP[4];
  //     this.otp6 = OTP[5];
  //     if(this.cmndeclaration.BrowserBuild != 1)
  //       this.stop();
  //   }else{
  //     if(this.cmndeclaration.BrowserBuild != 1)
  //       this.stop();
  //   }
  // }

  



}
